import { trackEvent } from '../lib/analytics';

// Vaste mobiele actiebalk: keuzehulp is de belangrijkste conversiehelper en mag op mobiel
// niet achter het menu verdwijnen (plan). Alleen zichtbaar < 860px (zie styles.css).
export function MobileStickyBar() {
  return (
    <div className="mobileStickyBar" role="navigation" aria-label="Snelle acties">
      <a
        className="mobileStickyCta primary"
        href="/keuzehulp/"
        onClick={() => trackEvent({ event: 'cta_click', location: 'mobile_sticky', label: 'Doe de keuzehulp', routeFamily: 'home', placement: 'sticky' })}
      >
        Doe de keuzehulp
      </a>
      <a
        className="mobileStickyCta secondary"
        href="/collecties/startersets/"
        onClick={() => trackEvent({ event: 'cta_click', location: 'mobile_sticky', label: 'Bekijk startersets', routeFamily: 'home', placement: 'sticky' })}
      >
        Bekijk startersets
      </a>
    </div>
  );
}
